import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {InputType} from "../../../../common/components/input/enum/InputType";
import {FormGroup, Validators} from '@angular/forms';
import {Country} from "../../../../common/components/input/interfaces/Country";
import {ClaimMerchantRequest} from "../../../../common/interfaces/ClaimMerchantRequest";
import {MerchantApi} from "../../../../common/apis/merchant-api";
import {
  ClaimBusinessSubmittedDialogComponent
} from "../claim-business-submitted-dialog/claim-business-submitted-dialog.component";
import {Field} from "../../../../common/enums/Field";
import {ValidationErrorType} from "../../../../common/enums/ValidationErrorType";

@Component({
  selector: 'app-claim-business-dialog',
  templateUrl: './claim-business-dialog.component.html',
  styleUrls: ['./claim-business-dialog.component.scss']
})
export class ClaimBusinessDialogComponent {

  emailLabel = $localize`:@@emailLabel:Email`
  nameLabel = $localize`:@@nameLabel:Name`
  submit = $localize`:@@submitLabel:Submit`
  mobile = $localize`:@@contactUsMobileNumber:Mobile Number`
  code = $localize`:@@code:Code`

  InputType = InputType
  Validators = Validators
  claimBusinessForm: FormGroup = new FormGroup({})
  countries: Country[] = [{
    nameEn: "Egypt",
    nameAr: "مصر",
    countryCode: "20",
    iso2letter: "EG",
    iso3letter: "EGY",
    createdAt: ""
  }]

  loading = false
  serverErrorMessage: string | null = null

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { merchantId: string },
    public dialogRef: MatDialogRef<ClaimBusinessDialogComponent>,
    public merchantApi: MerchantApi,
    public dialog: MatDialog
  ) {
  }

  closeDialog() {
    this.dialogRef.close()
  }

  claim() {
    if (this.claimBusinessForm.valid) {
      let claimRequest: ClaimMerchantRequest = {
        name: this.claimBusinessForm.get('name')?.value ?? "",
        email: this.claimBusinessForm.get('email')?.value ?? "",
        countryCode: "20",
        phoneNumber: this.claimBusinessForm.get('mobile')?.value
      }
      this.loading = true
      this.merchantApi.claimMerchant(this.data.merchantId, claimRequest).subscribe({
        next: () => {
          this.loading = false
          this.closeDialog()
          this.dialog.open(ClaimBusinessSubmittedDialogComponent, {
            width: '37rem'
          });
        },
        error: error => {
          this.loading = false
            // /validation/merchant-claim/duplicate
          this.resetErrorMessages()
          // serverErrorMessage = ""
          console.log(error)
          if (Array.isArray(error)) {
            // TODO Check for server-side per field error messages.
            error.map(singleError => {
              if (singleError.field == Field.MERCHANT_CLAIM) {
                if (singleError.errorType == ValidationErrorType.DUPLICATE) {
                  this.serverErrorMessage = $localize`:@@merchantClaimAlreadyExists:This request already exists. Please check your email for further instructions.`
                }
              }
            })
          }
          else {
            this.serverErrorMessage = $localize`:@@somethingWentWrong:Something went wrong. Please try again later or contact support.`
          }
        }
      })
    }
  }

  resetErrorMessages()
  {
    this.serverErrorMessage = null
  }
}
